module.exports = __webpack_public_path__ + "static/img/mid-icon.f5a9299.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my-irish-date/mid-icon.png
// module id = qnnh
// module chunks = 0